export default {
  name: 'BaseButton',
  props: {
    className: {
      type: String,
    },
    spinner: {
      type: Boolean,
      default: false,
    },
    type: {
      default: 'button',
      validator(value) {
        return ['button', 'submit', 'reset'].indexOf(value) !== -1;
      },
    },
    variant: {
      default: 'solid',
      validator(value) {
        return ['solid', 'outline', 'ghost'].indexOf(value) !== -1;
      },
    },
    color: {
      default: 'primary',
      validator(value) {
        return ['primary', 'red', 'green', 'blue'].indexOf(value) !== -1;
      },
    },
  },
};
